<div class="modal fade" id="unavailabilityModal" tabindex="-1" role="dialog" aria-labelledby="unavailabilityLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form (ngSubmit)="save()" novalidate>
        <div class="modal-header">
          <h5 class="modal-title" id="unavailabilityLabel">
            <span class="unavailability-swatch"></span>
            {{ readOnly ? 'Indisponibilité' : (editedId === null ? 'Nouvelle indisponibilité' : 'Modifier l\'indisponibilité') }}
          </h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body">
          @if (error) {
            <div class="alert alert-danger py-2">{{ error }}</div>
          }

          <fieldset [disabled]="readOnly">
            <div class="form-group">
              <label for="unavMonitor">Moniteur</label>
              <select id="unavMonitor" name="monitorId" class="form-control" [(ngModel)]="monitorId" [disabled]="monitors.length === 1 || readOnly">
                <option [ngValue]="null" disabled>Choisir un moniteur</option>
                @for (m of monitors; track m) {
                  <option [ngValue]="m.id">{{ m.firstname }} {{ m.lastname }}</option>
                }
              </select>
            </div>

            <div class="form-group">
              <label class="d-block">Durée</label>
              <div class="btn-group btn-group-sm w-100" role="group">
                <button type="button" class="btn" [ngClass]="mode === 'DAY' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="mode = 'DAY'">Journée</button>
                <button type="button" class="btn" [ngClass]="mode === 'PERIOD' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="mode = 'PERIOD'">Période</button>
                <button type="button" class="btn" [ngClass]="mode === 'SLOT' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="mode = 'SLOT'">Créneau horaire</button>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group" [ngClass]="mode === 'PERIOD' ? 'col-6' : 'col-12'">
                <label for="unavDate">{{ mode === 'PERIOD' ? 'Du' : 'Date' }}</label>
                <input id="unavDate" name="date" type="date" class="form-control" [(ngModel)]="date" required>
              </div>
              @if (mode === 'PERIOD') {
                <div class="form-group col-6">
                  <label for="unavDateEnd">Au (inclus)</label>
                  <input id="unavDateEnd" name="dateEnd" type="date" class="form-control" [(ngModel)]="dateEnd" [min]="date" required>
                </div>
              }
            </div>

            @if (mode === 'SLOT') {
              <div class="form-row">
                <div class="form-group col-6">
                  <label for="unavHourStart">De</label>
                  <select id="unavHourStart" name="hourStart" class="form-control" [(ngModel)]="hourStart">
                    @for (h of hours; track h) {
                      <option [ngValue]="h">{{ h }}</option>
                    }
                  </select>
                </div>
                <div class="form-group col-6">
                  <label for="unavHourEnd">À</label>
                  <select id="unavHourEnd" name="hourEnd" class="form-control" [(ngModel)]="hourEnd">
                    @for (h of hours; track h) {
                      <option [ngValue]="h">{{ h }}</option>
                    }
                  </select>
                </div>
              </div>
            }

            <div class="form-group">
              <label for="unavReason">Motif</label>
              <select id="unavReason" name="reason" class="form-control" [(ngModel)]="reason">
                @for (r of reasons; track r) {
                  <option [ngValue]="r.value">{{ r.label }}</option>
                }
              </select>
            </div>

            <div class="form-group mb-0">
              <label for="unavComment">Commentaire (facultatif)</label>
              <input id="unavComment" name="comment" class="form-control" maxlength="255" [(ngModel)]="comment">
            </div>
          </fieldset>

          @if (!readOnly) {
            <small class="d-block text-muted mt-3">
              <i class="fa fa-info-circle"></i> Les créneaux libres du moniteur sur cette période seront supprimés.
              Les heures déjà réservées pour un élève doivent être déplacées avant.
            </small>
          }
        </div>

        <div class="modal-footer">
          @if (!readOnly && editedId !== null) {
            @if (!confirmDelete) {
              <button type="button" class="btn btn-outline-danger me-auto" (click)="confirmDelete = true">Supprimer</button>
            }
            @if (confirmDelete) {
              <span class="me-auto">
                Confirmer ? <button type="button" class="btn btn-sm btn-danger" (click)="remove()">Oui, supprimer</button>
              </span>
            }
          }
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ readOnly ? 'Fermer' : 'Annuler' }}</button>
          @if (!readOnly) {
            <button type="submit" class="btn btn-primary" [disabled]="saving">
              @if (saving) {
                <span class="spinner-border spinner-border-sm"></span>
                } Enregistrer
              </button>
            }
          </div>
        </form>
      </div>
    </div>
  </div>
